
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireforpunetomaharashtradarshan() {



    const cardData =
    {
        keyword: 'Bus hire for Pune to Maharashtra Darshan',
        heading: 'Amruta Travels: Bus hire for Pune to Maharashtra Darshan',
        headingDescription: 'Amruta Travels offers Bus on Rent for Pune to Maharashtra Darshan, providing a reliable and comfortable transportation solution for your spiritual journey to the eight revered Ganpati temples in Maharashtra. Whether you are planning a family pilgrimage, group tour, or corporate outing, our well-maintained buses ensure a smooth and devotional experience. Choose from our range of buses, including 32-seater, 35-seater, 40-seater, 45-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your Ashtavinayak Darshan from Pune simple and stress-free. Book your bus with Amruta Travels and embark on a journey of faith and comfort!',


        top: 'Top Places to Visit in Maharashtra with Amruta Travels',
"topPlaces": [
  {
    "title": "Ajanta and Ellora Caves, Aurangabad",
    "description": "These UNESCO World Heritage Sites are renowned for their exquisite rock-cut caves. Ajanta features 30 Buddhist caves adorned with intricate frescoes and sculptures dating back to the 2nd century BCE. Ellora boasts 34 caves representing Buddhist, Hindu, and Jain traditions, with the Kailasa Temple being a monolithic marvel carved from a single rock."
  },
  {
    "title": "Gateway of India, Mumbai",
    "description": "An iconic arch-monument built in 1924, the Gateway of India overlooks the Arabian Sea and stands as a symbol of Mumbai's colonial history. It's a popular gathering spot for locals and tourists, offering ferry rides to Elephanta Caves and views of the Taj Mahal Palace Hotel."
  },
  {
    "title": "Mahabaleshwar, Satara District",
    "description": "A picturesque hill station nestled in the Western Ghats, Mahabaleshwar is known for its strawberry farms, lush forests, and panoramic viewpoints like Arthur's Seat and Elephant's Head Point. The town also houses the ancient Mahabaleshwar Temple dedicated to Lord Shiva."
  },
  {
    "title": "Shirdi, Ahmednagar District",
    "description": "Shirdi is a revered pilgrimage site, home to the Shri Sai Baba Sansthan Temple. Devotees from across the globe visit to pay homage to Sai Baba, a spiritual leader known for his teachings on love, forgiveness, and charity."
  },
  {
    "title": "Lonavala and Khandala, Pune District",
    "description": "These twin hill stations are famous for their scenic landscapes, waterfalls, and trekking trails. Attractions include the Bhushi Dam, Tiger's Leap, and the ancient Karla and Bhaja Caves. They're popular weekend getaways from Mumbai and Pune."
  },
  {
    "title": "Panchgani, Satara District",
    "description": "Surrounded by five hills, Panchgani offers a serene environment with attractions like Table Land, Sydney Point, and Parsi Point. The town is also known for its boarding schools and colonial-era architecture."
  },
  {
    "title": "Alibaug, Raigad District",
    "description": "A coastal town known for its clean beaches, historic forts, and seafood cuisine. Key attractions include Alibaug Beach, Kolaba Fort, and the tranquil Kihim Beach, making it a favored spot for beach lovers."
  },
  {
    "title": "Tarkarli, Sindhudurg District",
    "description": "Tarkarli is renowned for its pristine beaches and clear waters, ideal for snorkeling and scuba diving. The nearby Sindhudurg Fort, built by Shivaji Maharaj, adds historical significance to the region."
  },
  {
    "title": "Nashik, Nashik District",
    "description": "Known as the 'Wine Capital of India,' Nashik boasts numerous vineyards and wineries. It's also a significant religious site, hosting the Kumbh Mela every 12 years and housing temples like Trimbakeshwar and Kalaram."
  },
  {
    "title": "Tadoba Andhari Tiger Reserve, Chandrapur District",
    "description": "One of India's premier tiger reserves, Tadoba offers rich biodiversity with a significant population of Bengal tigers, leopards, and various bird species. Safari tours provide an opportunity to witness wildlife in their natural habitat."
  }
],



  "services": [
    {
      "name": "Pune to Kolhapur Bus Hire",
      "description": "Amruta Travels offers convenient and reliable bus rental services from Pune to Kolhapur. Whether you're planning a religious visit to Mahalaxmi Temple or a family tour, our buses ensure a smooth and comfortable journey with AC and non-AC options."
    },
    {
      "name": "Pune to Bhandardara Bus on Rent",
      "description": "Explore the scenic beauty of Bhandardara with our bus rental services from Pune. Ideal for nature lovers, trekkers, and weekend getaways, our buses are equipped for long-distance travel with experienced drivers and spacious seating."
    },
    {
      "name": "Pune to Pandharpur Bus On Rent",
      "description": "Visit the sacred town of Pandharpur with Amruta Travels. We provide clean, comfortable, and timely bus services from Pune to Pandharpur for spiritual yatras, family trips, or group tours, complete with onboard amenities."
    },
    {
      "name": "Pune to Tuljapur Darshan Bus Hire",
      "description": "Embark on a spiritual journey to Tuljapur Bhavani Temple with our bus rental services. Amruta Travels ensures a safe and serene darshan experience with a fleet of reliable buses and courteous drivers."
    },
    {
      "name": "Pune to Jyotiba Bus Hire",
      "description": "Amruta Travels offers Pune to Jyotiba Temple bus hire for pilgrimage groups and families. Our buses are available in various seating capacities and provide a comfortable and safe travel experience."
    },
    {
      "name": "Pune to Nashik Darshan Bus Hire",
      "description": "Plan a Nashik Darshan tour from Pune with Amruta Travels’ premium buses. Cover major religious and cultural sites such as Panchavati, Saptashrungi, and more in comfort and safety."
    },
    {
      "name": "Pune to Trimbakeshwar Bus on Rent",
      "description": "Travel to the sacred Trimbakeshwar Jyotirlinga from Pune with our AC and non-AC buses. Ideal for small or large groups, our services ensure timely and peaceful pilgrimage travel."
    },
    {
      "name": "Pune to Bhimashankar Bus Tour Package",
      "description": "Amruta Travels provides Bhimashankar Bus Tour Packages from Pune for a complete spiritual retreat. Our package includes comfortable travel, experienced drivers, and planned darshan timings for a smooth yatra."
    },
    {
      "name": "Pune to Konkan Darshan Bus Package",
      "description": "Explore the picturesque Konkan coast with our curated Konkan Darshan bus package from Pune. Visit Ratnagiri, Ganpatipule, Sindhudurg, and more in AC comfort with well-maintained buses and experienced tour staff."
    },
    {
      "name": "Pune to Sade Teen Shakti Peeth Package",
      "description": "Book your Sade Teen Shakti Peeth Yatra from Pune with Amruta Travels. Visit revered temples like Tuljapur, Kolhapur, and Mahurgad in a spiritually enriching and professionally managed tour."
    },
    {
      "name": "5 Jyotirlinga Darshan From Pune Maharashtra",
      "description": "Amruta Travels offers a 5 Jyotirlinga Darshan tour from Pune covering the sacred sites of Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Our package is perfect for devotees seeking a well-planned pilgrimage."
    },
    {
      "name": "Ashtavinayak Tour from Pune by Bus",
      "description": "Experience the spiritual journey of the eight Ganpati temples with Amruta Travels’ Ashtavinayak Tour from Pune. We offer daily and weekend packages with AC buses and guided routes for your comfort."
    },
    {
      "name": "Ashtavinayak Darshan From Pune by Bus",
      "description": "Our Ashtavinayak Darshan by bus from Pune is designed for groups and families looking for a comprehensive pilgrimage. Enjoy AC comfort, onboard support, and temple timings coordinated by our travel experts."
    },
    {
      "name": "Pune Darshan Bus Hire on Rent",
      "description": "Amruta Travels offers affordable Pune Darshan bus rentals for sightseeing across the city’s historical and cultural landmarks. Perfect for tourists, school groups, and corporates, our buses ensure a rich city tour experience."
    },
    {
      "name": "Pune to Mumbai Darshan Bus On Rent",
      "description": "Explore Mumbai’s famous tourist attractions with our Pune to Mumbai Darshan bus rental service. From Gateway of India to Siddhivinayak Temple, enjoy a full-day or multi-day tour in AC buses with professional drivers."
    },
    {
      "name": "Pune to Nagpur Tadoba Darshan Bus on Rent",
      "description": "Plan your wildlife and spiritual journey with a Pune to Nagpur Tadoba tour bus. Amruta Travels offers AC tourist buses for long-distance travel to Tadoba National Park and nearby temples, ideal for nature and adventure enthusiasts."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Bus Hire", "Pune to Bhandardara Bus on Rent"],
    ["Pune to Pandharpur Bus On Rent", "Pune to Tuljapur Darshan Bus Hire"],
    ["Pune to Jyotiba Bus Hire", "Pune to Nashik Darshan Bus Hire"],
    ["Pune to Trimbakeshwar Bus on Rent", "Pune to Bhimashankar Bus Tour Package"],
    ["Pune to Konkan Darshan Bus Package", "Pune to Sade Teen Shakti Peeth Package"],
    ["5 Jyotirlinga Darshan From Pune Maharashtra", "Ashtavinayak Tour from Pune by Bus"],
    ["Ashtavinayak Darshan From Pune by Bus", "Pune Darshan Bus Hire on Rent"],
    ["Pune to Mumbai Darshan Bus On Rent", "Pune to Nagpur Tadoba Darshan Bus on Rent"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comprehensive Bus Hire for Pune to Maharashtra Darshan",
    "WhyChoosedescription": "Amruta Travels offers specialized bus hire services for Maharashtra Darshan from Pune, covering the state’s most iconic religious, historical, and natural landmarks. Whether it’s a multi-day pilgrimage, educational tour, cultural heritage exploration, or group sightseeing, we provide safe, comfortable, and reliable travel tailored to your itinerary. Our service ensures that you discover the beauty of Maharashtra with ease and convenience."
  },
  {
    "WhyChooseheading": "Cover Major Attractions Across Maharashtra",
    "WhyChoosedescription": "Our Maharashtra Darshan routes typically include key spiritual sites like Shirdi, Trimbakeshwar, Pandharpur, Kolhapur, Bhimashankar, and Ashtavinayak temples, as well as popular tourist spots like Ajanta-Ellora, Lonar Crater, Mahabaleshwar, Lonavala, Raigad Fort, and coastal Konkan destinations. We work with you to create a custom route that fits your group’s travel goals and timeframe."
  },
  {
    "WhyChooseheading": "Spacious Buses for Groups of All Sizes",
    "WhyChoosedescription": "Choose from a range of 17, 20, 32, 35, 40, 45, and 50-seater AC and Non-AC buses based on your group size. Our buses come with ample seating, comfortable interiors, large windows for scenic views, and storage space for luggage. Ideal for families, tour operators, schools, corporate teams, and religious groups looking for a relaxed and safe journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with All Routes in Maharashtra",
    "WhyChoosedescription": "Our drivers are well-versed in the geography of Maharashtra and have deep knowledge of roads leading to temples, forts, hill stations, beaches, and pilgrimage centers. They ensure smooth travel, timely arrivals, and guidance at each stop. Their courteous behavior and understanding of local travel dynamics make a significant difference in multi-location trips."
  },
  {
    "WhyChooseheading": "Customizable Multi-Day Tour Plans",
    "WhyChoosedescription": "Every Maharashtra Darshan itinerary is fully customizable. We help you build a schedule based on your destinations, available days, and group preferences. Whether you're planning a 3-day, 5-day, or 7+ day tour, we arrange stopovers, hotel coordination (on request), rest breaks, and sightseeing time to make the most of your journey across the state."
  },
  {
    "WhyChooseheading": "Affordable Packages with All-Inclusive Pricing",
    "WhyChoosedescription": "We offer affordable Maharashtra Darshan bus hire packages with transparent pricing that covers fuel, tolls, driver allowance, and taxes. Whether you need a basic Non-AC vehicle or a premium luxury coach, we ensure fair pricing with no hidden fees—making large group travel both economical and convenient."
  },
  {
    "WhyChooseheading": "Clean, Safe, and Comfortable Buses",
    "WhyChoosedescription": "All our buses are regularly cleaned, sanitized, and maintained to deliver a high standard of hygiene and safety. Especially during long-distance and multi-day tours, comfort is key—and we provide ergonomic seats, smooth suspension, working air conditioning (for AC models), and emergency backup support for a stress-free experience."
  },
  {
    "WhyChooseheading": "Easy Booking Process with Full Tour Support",
    "WhyChoosedescription": "Booking your Pune to Maharashtra Darshan bus is quick and easy. Our team assists with planning your route, scheduling, and pickup/drop coordination. You can book online, call us directly, or visit our office. Throughout your trip, we offer continuous support and communication to handle any changes, issues, or requests from start to finish."
  }
]

















    }

const faqData = [
  {
    question: 'What is included in the Maharashtra Darshan bus tour from Pune?',
    answer: 'Our Maharashtra Darshan package includes bus transportation, fuel, tolls, parking, experienced drivers, and customizable itineraries to cover key destinations like Nashik, Shirdi, Aurangabad, Lonavala, Mahabaleshwar, Kolhapur, and more.',
  },
  {
    question: 'How many days does the Maharashtra Darshan tour typically take?',
    answer: 'The tour duration varies depending on your selected destinations. Most Maharashtra Darshan tours range from 5 to 10 days. We help plan the route to ensure comfortable travel and ample time at each location.',
  },
  {
    question: 'What types of buses are available for the Maharashtra Darshan tour?',
    answer: 'We offer a fleet of AC and non-AC buses in 32, 35, 40, 45, and 50-seater configurations. Luxury and deluxe coaches with push-back seats and extra legroom are also available for long-distance travel.',
  },
  {
    question: 'Can I customize the Maharashtra Darshan itinerary?',
    answer: 'Yes, the itinerary is fully customizable based on your group’s interest, travel dates, and the number of days. You can include religious sites, hill stations, beaches, forts, and more across Maharashtra.',
  },
  {
    question: 'Are meals and accommodation included in the bus rental package?',
    answer: 'We offer flexible options. You can choose bus-only service or opt for an all-inclusive package that includes accommodation, meals, and sightseeing assistance.',
  },
  {
    question: 'Is this tour suitable for family and senior citizen groups?',
    answer: 'Absolutely! Our buses are comfortable and the routes are planned to ensure minimal fatigue. We’ve successfully organized Maharashtra Darshan tours for senior citizens, families, and school groups.',
  },
  {
    question: 'Are your drivers familiar with Maharashtra tourist routes?',
    answer: 'Yes, our drivers are well-trained and have years of experience navigating key tourist routes across Maharashtra. They ensure a safe and timely journey.',
  },
  {
    question: 'What is the pricing for a Maharashtra Darshan bus rental from Pune?',
    answer: 'The cost depends on the number of days, destinations covered, type of bus, and services opted. Contact us for a customized quote tailored to your plan.',
  },
  {
    question: 'Why choose Amruta Travels for Maharashtra Darshan?',
    answer: 'Amruta Travels provides clean, well-maintained buses, experienced staff, and personalized service. We are known for our punctuality, customer satisfaction, and smooth execution of long-distance tours.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rajendra Shinde',
    role: 'Tour Coordinator, Pune',
    text: 'We organized a 7-day Maharashtra Darshan with Amruta Travels and visited places like Shirdi, Aurangabad, Mahabaleshwar, and Kolhapur. The bus was very comfortable and the service was top-notch. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Lata Jagtap',
    role: 'Senior Citizen Group Organizer',
    text: 'Our senior citizens group had a wonderful Maharashtra Darshan tour thanks to Amruta Travels. The bus was clean, the itinerary was well-planned, and the driver was very helpful throughout. Excellent service!',
    rating: 5,
  },
];
































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Maharashtra Darshan Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-maharashtra-darshan.jpg",
  "description": "Book your Maharashtra Darshan bus tour from Pune with Amruta Travels. We offer customized bus packages for popular pilgrimage sites like Kolhapur, Pandharpur, Nashik, Trimbakeshwar, Bhimashankar, Sade Teen Shakti Peeth, and 5 Jyotirlinga Darshan. Choose from AC, non-AC buses, and mini buses for a comfortable and affordable pilgrimage journey.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000", // Adjust price based on specific Darshan packages
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-maharashtra-darshan-bus-hire"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Maharashtra Darshan Bus Hire | Kolhapur, Pandharpur, Nashik & More | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book your Maharashtra Darshan bus tour from Pune with Amruta Travels. Offering customized tours to Kolhapur, Pandharpur, Trimbakeshwar, Bhimashankar, Sade Teen Shakti Peeth & more. Affordable AC and non-AC bus options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforpunetomaharashtradarshan;